import { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { FileItem } from '../../../../reusable'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { useNavigate } from 'react-router-dom'
import api from '../../../../../helpers/apiRequester'
import { getLoginUrl } from '../../../../../helpers/authConfig'
import Select from 'react-select'
import { ProgressView } from '../progressView'

export const FilesView = (props: { caseRef: string }) => {
    const navigate = useNavigate()
    const { caseRef } = props
    const [dataReady, setDataReady] = useState(false)
    const [allFiles, setAllFiles] = useState([])

    useEffect(() => {
        if (!dataReady) {
            getData()
        }
    }, [dataReady])

    useEffect(() => {
        Loading.circle('Getting Files...')
        getData()
    }, [caseRef])
    const getData = async () => {
        try {
            const apiResponse = await api({ url: 'pcp-sentinel/all-files', data: { case_ref: caseRef } })
            const data = apiResponse.data

            if (data.success) {
                setAllFiles(data.documents)
                setDataReady(true)
            }
            Loading.remove()
        } catch (error: any) {
            console.log(error)
            Loading.remove()
            if (error?.response.status == 401) {
                Report.failure('Session Timed Out', 'Please log in again to continue.', 'Okay', () => {
                    window.location.href = getLoginUrl()
                })
            } else {
                console.log('')
                window.location.href = getLoginUrl()
            }
        }
    }

    return (
        <div className={styles.filesView}>
            <h4>Cloud Storage</h4>
            <div className={styles.viewFilesContainer}>
                {allFiles && allFiles.length > 0 ? (
                    allFiles.map((filegroup: any, i: number) => {
                        return (
                            <div className={styles.fileGroup} key={i}>
                                <h4>{filegroup.title.split('_').join(' ')}</h4>
                                <div className={styles.files}>
                                    {filegroup.files.map((file: any, i2: number) => (
                                        <div key={i2}>
                                            <p>
                                                {file.filename}{' '}
                                                <a target="__blank" href={file.signedUrl}>
                                                    Download
                                                </a>
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )
                    })
                ) : (
                    <></>
                )}
            </div>
        </div>
    )
}
